<template>
  <div>
    <button v-if="user" @click.stop="toggle" class="butn login-button">
      {{ user.username }}
      <div class="avatar-wrap">
        <div
          v-if="avatar"
          class="avatar"
          style="color: red"
          :style="{ 'background-image': `url(${avatar})` }"
          :aria-label="user.username + ' avatar'"
        ></div>
        <i v-else="" class="dfc-user-icon" v-html="UserIcon"></i>
      </div>

      <ul class="login-dropdown" :class="{ open: isOpen }">
        <li>
          <a
            href="https://accounts.bistudio.com"
            target="_blank"
            rel="nofollow me noopener noreferrer"
            >your account</a
          >
        </li>
        <li><a href="/api/auth/logout" class="biAccLogoutButt">logout</a></li>
      </ul>
    </button>

    <a v-else="" href="/api/auth/login" class="login-button">
      Log in
      <div class="avatar-wrap">
        <i class="dfc-login-icon" v-html="UserIcon"></i>
      </div>
    </a>
  </div>
</template>

<script>
import UserIcon from "../../assets/icons/user.svg";

export default {
  name: "account",
  props: {
    user: {}
  },
  data() {
    return {
      UserIcon,
      isOpen: false
    };
  },
  computed: {
    avatar() {
      return this.user && this.user.avatars
        ? this.user.avatars.default.url + "?r=r"
        : null;
    }
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    }
  },
  created() {
    window.addEventListener("click", () => {
      if (this.isOpen) {
        this.isOpen = false;
      }
    });
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/vars";
@import "../../assets/styles/mixins";

.butn {
  @include butn;
}

a {
  color: #fff;
  text-decoration: none;
}

.login-button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0.25em;
  font-size: 14px;

  @media (max-width: $screen-sm-max) {
    width: 100%;
  }
}

.avatar-wrap {
  margin-left: 0.5em;
  line-height: 0;
  font-size: 2em;
  color: #fff;
}

.avatar {
  width: 1em;
  height: 1em;
  border-radius: 50%;
  background: #fff no-repeat center;
  background-size: cover;
}

.login-dropdown {
  margin: 0;
  padding: 0;
  list-style-type: none;

  position: absolute;
  top: 42px;
  right: 3px;
  background-color: #333;
  border-radius: 4px;
  box-shadow: 3px 3px 5px 1px #000;
  display: none;
  z-index: 200;

  &.open {
    display: inline-block;
  }

  &::before {
    content: "";
    position: absolute;
    top: -8px;
    right: 7px;
    display: inline-block;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid #333;
  }

  a {
    display: block;
    padding: 0.75em 2em;
    white-space: nowrap;
    text-transform: lowercase;

    &:hover {
      background-color: rgba(255, 255, 255, 0.25);
    }
  }
}
</style>

<style lang="scss">
.dfc-user-icon {
  svg {
    width: 1em;
    height: 1em;
    fill: currentColor;
  }
}

.dfc-login-icon {
  svg {
    width: 0.9em;
    height: 0.9em;
    fill: currentColor;
  }
}
</style>
